export const BUYER_OBJECTIVES = [
    "Condo Conversion",
    "Investment",
    "Occupancy",
    "Redevelopment",
    "Renovation"
]